module.exports = __webpack_public_path__ + "img/dhht-5.e1b731d4.png";